module.exports = "https://assets.calmac.co.uk/scripts/apps/site-services/1.1/img/redLink.svg";